// Location service using country-state-city package
import { Country, State, City } from 'country-state-city';

export const LocationService = {
  // Get all countries
  getAllCountries: () => {
    return Country.getAllCountries().map(country => ({
      value: country.isoCode,
      label: country.name,
      flag: country.flag
    }));
  },

  // Get states by country code
  getStatesByCountry: (countryCode) => {
    if (!countryCode) return [];
    return State.getStatesOfCountry(countryCode).map(state => ({
      value: state.isoCode,
      label: state.name,
      stateCode: state.isoCode
    }));
  },

  // Get cities by country and state code
  getCitiesByCountryAndState: (countryCode, stateCode) => {
    if (!countryCode) return [];
    return City.getCitiesOfState(countryCode, stateCode).map(city => ({
      value: city.name,
      label: city.name,
      latitude: city.latitude,
      longitude: city.longitude
    }));
  },

  // Get cities by country only (if state is not selected)
  getCitiesByCountry: (countryCode) => {
    if (!countryCode) return [];
    return City.getCitiesOfCountry(countryCode).map(city => ({
      value: city.name,
      label: city.name,
      stateCode: city.stateCode,
      latitude: city.latitude,
      longitude: city.longitude
    }));
  },

  // Get country details by ISO code
  getCountryByCode: (countryCode) => {
    return Country.getCountryByCode(countryCode);
  },

  // Get state details by country and state code
  getStateByCode: (countryCode, stateCode) => {
    return State.getStateByCodeAndCountry(stateCode, countryCode);
  }
};